import { createContext, useContext, useState, ReactNode } from "react";

interface PinnedChecklistsContextType {
  pinnedChecklistIds: number[];
  togglePinChecklist: (checklistId: number) => void;
  isPinnedChecklist: (checklistId: number) => boolean;
}

const PinnedChecklistsContext = createContext<PinnedChecklistsContextType | undefined>(undefined);

export const PinnedChecklistsProvider = ({ children }: { children: ReactNode }) => {
  const [pinnedChecklistIds, setPinnedChecklistIds] = useState<number[]>(() => {
    const stored = localStorage.getItem("pinnedChecklist");
    return stored ? JSON.parse(stored) : [];
  });

  const togglePinChecklist = (checklistId: number) => {
    setPinnedChecklistIds((prev) => {
      const newPinned = prev.includes(checklistId)
        ? prev.filter((id) => id !== checklistId)
        : [...prev, checklistId];
      localStorage.setItem("pinnedChecklist", JSON.stringify(newPinned));
      return newPinned;
    });
  };

  const isPinnedChecklist = (checklistId: number) => {
    return pinnedChecklistIds.includes(checklistId);
  };

  return (
    <PinnedChecklistsContext.Provider value={{ pinnedChecklistIds, togglePinChecklist, isPinnedChecklist }}>
      {children}
    </PinnedChecklistsContext.Provider>
  );
};

export const usePinnedChecklists = () => {
  const context = useContext(PinnedChecklistsContext);
  if (!context) {
    throw new Error("usePinnedChecklists must be used within a PinnedChecklistsProvider");
  }
  return context;
};
